import NewsPage from "../news/NewsPage";
import Mpdata from "../../pages/mp/Mpdata";

const cinema = () => {
  return (
    <NewsPage
      category="cinema"
      staticData={[Mpdata]} // optional
    />
  );
};

export default cinema;
